import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import "./Edit.css";
import Breadcrumb from "../../../Layout/Breadcrumb/Breadcrumb";
import Header from "../../../Layout/Header/Header";
import Footer from "../../../Layout/Footer/Footer";
import Nav from "../../../Layout/Nav/Nav";
// import { useState } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import ButtonCall from "../../UiSpecification/Button/Button";
import UnLinkButton from "../../UiSpecification/UnLinkButton/UnLinkButton";
import ActionButtonCall from "../../UiSpecification/ActionButton/ActionButton";

import { MasterData } from "../../../Helpers/Data/MasterData/MasterData";
import { CatMasterData } from "../../../Helpers/Data/CatMasterData/CatMasterData";
import { Company } from "../../../Helpers/Data/Company/Company";
import { Contact } from "../../../Helpers/Data/Contact/Contact";
import { Unit } from "../../../Helpers/Data/Unit/Unit";

import jobImageOne from "../../../../Images/job-1.png";
import jobImageTwo from "../../../../Images/job-2.png";

import DataTable, { createTheme } from "react-data-table-component";

// function ActionButtonCall(props) {

//   return (
//     iconButtons
//     .filter((ibtn) => ibtn.name == props.btnname)
//     .map((filteredIbtn) => <li key={filteredIbtn.id}>{filteredIbtn.button}</li>)
//   );
// }

function AddJob() {
  const [MasterDataStore, setMasterDataStore] = useState(MasterData);
  // console.log({ MasterDataStore });

  const [CatMasterDataStore, setCatMasterDataStore] = useState(CatMasterData);
  // console.log({ CatMasterDataStore });

  const [SelectedMasterDataStore, setSelectedMasterDataStore] = useState({
    MasterDataCategory: "",
  });
  const handleMasterDataInput = (e) => {
    setSelectedMasterDataStore({
      ...SelectedMasterDataStore,
      [e.target.name]: e.target.value,
    });
  };

  const [CompanyStore, setCompanyStore] = useState(Company);
  // console.log({ CompanyStore });

  const [ContactStore, setContactStore] = useState(Contact);
  // console.log({ ContactStore });

  const [SelectedCompanyStore, setSelectedCompanyStore] = useState({
    company: "",
  });
  const handleCpmpanyInput = (e) => {
    setSelectedCompanyStore({
      ...SelectedCompanyStore,
      [e.target.name]: e.target.value,
    });
  };
  // console.log({SelectedCompanyStore});

  // List Table
  const columns = [
    {
      name: "No",
      selector: (row) => row.code,
      sortable: true,
    },
    {
      name: "Title",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "NOS",
      selector: (row) => row.nos,
      sortable: true,
    },
    {
      name: "Unit",
      selector: (row) => row.unit,
      // width: "720px",
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => row.action,
      sortable: true,
    },
  ];

  const data = [
    {
      id: 1,
      code: "I001",
      name: "Checked central air conditioning unit",
      nos: 1,
      unit: "NOS",
      action: (
        <div className="icon-button-parent">
          {<ActionButtonCall btnname="close" />}
        </div>
      ),
    },
    {
      id: 2,
      code: "I002",
      name: "Installed thermostat wall plate",
      nos: 1,
      unit: "NOS",
      action: (
        <div className="icon-button-parent">
          {<ActionButtonCall btnname="close" />}
        </div>
      ),
    },
    {
      id: 3,
      code: "I003",
      name: "Re-wired low volt in to new one",
      nos: 5,
      unit: "NOS",
      action: (
        <div className="icon-button-parent">
          {<ActionButtonCall btnname="close" />}
        </div>
      ),
    },
    {
      id: 4,
      code: "I004",
      name: "Replaced new digital thermostat",
      nos: 1,
      unit: "NOS",
      action: (
        <div className="icon-button-parent">
          {<ActionButtonCall btnname="close" />}
        </div>
      ),
    },

    {
      id: 5,
      code: "I005",
      name: "Programed thermostat in to heat pump mode",
      nos: 3,
      unit: "NOS",
      action: (
        <div className="icon-button-parent">
          {<ActionButtonCall btnname="close" />}
        </div>
      ),
    },
  ];

  const [records, setRecords] = useState(data);

  // function handleFilter(event) {
  //   const newData = data.filter((row) => {
  //     return row.title.toLowerCase().includes(event.target.value.toLowerCase());
  //   });
  //   setRecords(newData);
  // }
  // End List Table

  // Add Item Modal
  const [showAddJob, setShowAddJob] = useState(false);
  const handleClose = () => setShowAddJob(false);
  const handleShow = () => setShowAddJob(true);

  const [modalType, setModalType] = useState("");

  // Add Item Inventory
  const [addJobInventoryType, SetaddJobInventoryType] = useState("master");

  // All Added items
  const [insrtedAllTypeItemStore, setinsrtedAllTypeItemStore] = useState([]);

  // Add Inventory Type Body
  // const [jobInventoryBodyType, SetjobInventoryBodyType] = useState("master");

  // Inventor Item Insert
  //   master
  // ======
  // selectMasterItem
  // MasterItemCount

  // custom
  // =====
  // CustomItemName
  // CustomItemDescription
  // CustomItemCount
  // CustomItemUnit

  //  ============= Master Item add ===========
  const [insertMasterItem, setinsertMasterItem] = useState({
    selectMasterItem: "",
    MasterItemCount: "",
  });
  const insertMasterItemParser = (e) => {
    setinsertMasterItem({
      ...insertMasterItem,
      [e.target.name]: e.target.value,
    });
  };
  const [insertMasterItemStore, setinsertMasterItemStore] = useState([]);

  //  ============ Custom Item Add ===========
  const [insertCustomItem, setinsertCustomItem] = useState({
    CustomItemName: "",
    CustomItemDescription: "",
    CustomItemCount: "",
    CustomItemUnit: "",
    CustomItemPrice: "",
  });
  const insertCustomItemParser = (e) => {
    setinsertCustomItem({
      ...insertCustomItem,
      [e.target.name]: e.target.value,
    });
  };
  const [insertCustomItemStore, setinsertCustomItemStore] = useState([]);

  // ======Submit=====

  // const SubmitinsertAllItemParser = (e) => {
  //   addJobInventoryType == "master"
  //     ?
  //     setinsertMasterItemStore({
  //       selectMasterItem: insertMasterItem.selectMasterItem,
  //       MasterItemCount: insertMasterItem.MasterItemCount,
  //     })  :
  // setinsertCustomItemStore({
  //   CustomItemName :insertCustomItem.CustomItemName,
  //   CustomItemDescription :insertCustomItem.CustomItemDescription,
  //   CustomItemCount :insertCustomItem.CustomItemCount,
  //   CustomItemUnit :insertCustomItem.CustomItemUnit,
  // });

  //   addJobInventoryType == "master"
  //   ? setinsrtedAllTypeItemStore({...insrtedAllTypeItemStore, insertMasterItemStore})
  //   : setinsrtedAllTypeItemStore({...insrtedAllTypeItemStore, insertCustomItemStore});
  // };

  const SubmitinsertAllItemParser = () => {
    if (addJobInventoryType == "master") {
      if (
        insertMasterItem.selectMasterItem != "" &&
        insertMasterItem.MasterItemCount != ""
      ) {
        setinsertMasterItemStore((insertMasterItemStore) => [
          ...insertMasterItemStore,
          insertMasterItem,
        ]);
        setinsrtedAllTypeItemStore((insrtedAllTypeItemStore) => [
          ...insrtedAllTypeItemStore,
          insertMasterItem,
        ]);
        // console.log(nameTwo);
        setinsertMasterItem({
          selectMasterItem: "",
          MasterItemCount: "",
        });
      }

      // setNameThree({
      //   ...nameThree,
      //   nameTwo,
      // });
      // working===setNameThree(prevStateArray => [...prevStateArray, nameTwo]);

      // console.log(nameThree);
    } else {
      if (
        insertCustomItem.CustomItemName != "" &&
        insertCustomItem.CustomItemDescription != "" &&
        insertCustomItem.CustomItemCount != "" &&
        insertCustomItem.CustomItemUnit != ""
      ) {
        setinsertCustomItemStore((insertCustomItemStore) => [
          ...insertCustomItemStore,
          insertCustomItem,
        ]);
        setinsrtedAllTypeItemStore((insrtedAllTypeItemStore) => [
          ...insrtedAllTypeItemStore,
          insertCustomItem,
        ]);
        // console.log(nameTwo);
        setinsertCustomItem({
          CustomItemName: "",
          CustomItemDescription: "",
          CustomItemCount: "",
          CustomItemUnit: "",
          CustomItemPrice: "",
        });
      }
      // setNameThree({
      //   ...nameThree,
      //   nameTwoB,
      // });
      // working====setNameThree(prevStateArray => [...prevStateArray, nameTwoB]);

      // console.log(nameThree);
    }
    // toggler == true ? console.log("True") : console.log("false");
  };

  console.log(insrtedAllTypeItemStore);

  const [note, setNote] = useState("Aaaaa <br> Bbbbbb <br> Ccccyc");

  return (
    <div className="page-con">
      <div className="page-nav">
        <Nav />
      </div>

      <div className="page-body">
        <Header />

        <div className="comb-sec breadcrumb-sec">
          <div className="container-fluid px-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb my-0">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/job">Job List</Link>
                </li>
                <li className="breadcrumb-item">
                  <span>Edit Job</span>
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="page-content-container">
          {
            // insrtedAllTypeItemStore.map((item) => (
            //                   <p>
            //                     <>
            //                       xx
            //                       {/* {SelectedCompanyStore.company} */}
            //                     </>
            //                   </p>
            //                 ))
          }

          <Container className="cus-con-elmt">
            <Row>
              <Col xs={12} md={12} lg={12}>
                <div className="page-top-info-style-2">
                  <div className="page-top-info-style-2-inner">
                    <div className="page-top-info-style-2-col page-top-info-style-2-col-3_1">
                      <div className="page-top-info-style-2-col-row-h">
                        Job No
                      </div>
                      <div className="page-top-info-style-2-col-row-c">
                        J001
                      </div>
                    </div>

                    <div className="page-top-info-style-2-col page-top-info-style-2-col-3_1">
                      <div className="page-top-info-style-2-col-row-h">
                        Job Date
                      </div>
                      <div className="page-top-info-style-2-col-row-c">
                        12/22/24
                      </div>
                    </div>

                    <div className="page-top-info-style-2-col page-top-info-style-2-col-3_1">
                      <div className="page-top-info-style-2-col-row-h">
                        Job Status
                      </div>
                      <div className="page-top-info-style-2-col-row-c">
                      Completed
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={12} lg={12}>
                <div className="form-group-con">
                  <Form.Label htmlFor="addJobTitle">Title</Form.Label>
                  <Form.Control
                    type="text"
                    id="addJobTitle"
                    value="Checked central AC and heating system"
                    // aria-describedby="passwordHelpBlock"
                  />
                  {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                </div>
              </Col>

              <Col
                xs={12}
                md={12}
                lg={12}
                className="lable-before_after-unsetter-con"
              >
                <div className="form-group-con">
                  <Form.Label htmlFor="addJobDesc">Description</Form.Label>
                  <FloatingLabel>
                    <Form.Control
                      as="textarea"
                      placeholder="Leave a comment here"
                      style={{ height: "100px" }}
                      id="addJobDesc"
                      value="At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio."
                    />
                  </FloatingLabel>
                </div>
              </Col>

              <Col xs={12} md={6} lg={6}>
                <div className="form-group-con">
                  <Form.Label htmlFor="addJobDate">Date</Form.Label>
                  <Form.Control
                    type="date"
                    id="addJobDate"
                    value="2024-12-22"
                    // aria-describedby="passwordHelpBlock"
                  />
                  {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                </div>
              </Col>

              <Col xs={12} md={6} lg={6}>
                <div className="form-group-con">
                  <Form.Label htmlFor="addJobCat">Category</Form.Label>
                  <Form.Select
                    id="addJobCat"
                    aria-label="Default select example"
                    disabled="disabled"
                  >
                    <option value="1">AC</option>
                    <option value="2">Painting</option>
                    <option value="3">Solar panel</option>
                    <option value="4">Gardening</option>
                  </Form.Select>
                </div>
              </Col>

              <Col xs={12} md={6} lg={6}>
                <div className="form-group-con">
                  <div className="form-group-con-btn">
                    <div className="form-group-con-btn-col-1">
                      <Form.Label htmlFor="addJobSelectCompany">
                        Company
                      </Form.Label>

                      <Form.Select
                        name="company"
                        value={SelectedCompanyStore.company}
                        onChange={handleCpmpanyInput}
                        id="company"
                        aria-label="Default select example"
                        disabled={true}
                      >
                        {/* <option>Select Company</option>
                        {CompanyStore.map((item) => (
                          <option key={item.id} value={item.code}>
                            {item.name}
                          </option>
                        ))} */}
                        <option>Las Ventanas</option>
                        <option>Saepe Eveniet</option>
                        <option>Voluptates Repudiandae</option>
                      </Form.Select>
                    </div>

                    {/* <div className="form-group-con-btn-col-2">
                      {
                        <UnLinkButton
                          trigerClick={handleShow}
                          modalStateAndValue={{
                            setState: setModalType,
                            setStateValue: "add-company",
                          }}
                          btnname="add"
                          title="Add New"
                        />
                      }
                    </div> */}
                  </div>
                </div>
              </Col>

              <Col xs={12} md={6} lg={6}>
                <div className="form-group-con">
                  <div className="form-group-con-btn">
                    <div className="form-group-con-btn-col-1">
                      <Form.Label htmlFor="addJobSelectCustomer">
                        Contact
                      </Form.Label>
                      <Form.Select
                        id="addJobSelectCustomer"
                        aria-label="Default select example"
                        disabled={true}
                      >
                        {/* <option>Select Customer</option>
                        {ContactStore.filter(
                          (contact) =>
                            contact.enable == 1 &&
                            contact.company == `${SelectedCompanyStore.company}`
                        ).map((item) => (
                          <option key={item.id} value={item.code}>
                            <>
                              {item.name}
                            </>
                          </option>
                        ))} */}
                        <option>Strathern Park</option>
                        <option>Lorem Ipsum</option>
                        <option>Atque Corrupti</option>
                        <option>Occaecati Cupiditate</option>
                        <option>Laborum Dolorum</option>
                      </Form.Select>
                    </div>

                    {/* <div className="form-group-con-btn-col-2">
                      {
                        <UnLinkButton
                          trigerClick={handleShow}
                          modalStateAndValue={{
                            setState: setModalType,
                            setStateValue: "add-contact",
                          }}
                          btnname="add"
                          title="Add New"
                        />
                      }
                    </div> */}
                  </div>
                </div>
              </Col>

              <Col xs={12} md={8} lg={8}>
                <div className="form-group-con">
                  <Form.Label htmlFor="addJobDate">Images</Form.Label>
                 <div className="i-list-input-con">
                  <p className="i-list-con">
                    <img className="job-view-i-1" src={jobImageOne} alt="" />
                    <img className="job-view-i-1" src={jobImageTwo} alt="" />
                  </p>
                  <Form.Control
                    type="file"
                    // aria-describedby="passwordHelpBlock"
                  style={{width:"300px"}}
                  />
                  {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                </div>
                </div>
              </Col>

              <Col xs={12} md={12} lg={12}>
                <br></br>
                <br></br>
                <div className="dataTable-con">
                  <div className="dataTable-serach-con dataTable-serach-con-button">
                    <div className="dataTable-serach-con-button-left"></div>

                    <div className="dataTable-serach-con-button-right">
                      {
                        <UnLinkButton
                          // urlto="/comingsoon"
                          trigerClick={handleShow}
                          modalStateAndValue={{
                            setState: setModalType,
                            setStateValue: "edit-item",
                          }}
                          btnname="add"
                          title="Add items"
                        />
                      }
                    </div>
                  </div>
                  <div
                    className="dataTable-table-con dataTable-table-guest-edit-item"
                    style={{ borderTop: "0px" }}
                  >
                    {/* <DataTable
                columns={columns}
                data={records}
                fixedHeader
                pagination
                // theme="solarized"
              /> */}

                    <Container
                      className="cus-con-elmt bottom-btn-set-sec"
                      style={{ marginTop: "0px" }}
                    >
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <div className="table-wrapper-con-elmt">
                            <table className="table table-stripped table-bordered custome-tbl-elmt cost-table">
                              <thead>
                                <tr>
                                  <th
                                    style={{ width: "auto", minWidth: "220px" }}
                                  >
                                    Title
                                  </th>
                                  <th style={{ width: "100px" }}>Type</th>
                                  <th style={{ width: "130px" }}>
                                    Unit Price (USD)
                                  </th>
                                  <th style={{ width: "75px" }}>Qty</th>
                                  <th style={{ width: "180px" }}>Discount</th>
                                  <th style={{ width: "150px" }}>
                                    Line Total (USD)
                                  </th>
                                  <th style={{ width: "50px" }}>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td align="left">
                                    Installed thermostat wall plate
                                  </td>
                                  <td align="left">Master</td>
                                  <td align="right">
                                    <div style={{ display: "flex" }}>
                                      <div style={{ width: "120px" }}>
                                        <Form.Control
                                          type="number"
                                          id=""
                                          name=""
                                          value="5000.00"
                                          // step="0.01"
                                          step="0.1"
                                          min="0"
                                          // aria-describedby="passwordHelpBlock"
                                        />
                                      </div>
                                    </div>
                                  </td>
                                  <td align="right">
                                    <div style={{ display: "flex" }}>
                                      <div style={{ width: "70px" }}>
                                        <Form.Control
                                          type="number"
                                          id=""
                                          name=""
                                          value="3"
                                          // step="0.01"
                                          step="1"
                                          min="0"
                                          // aria-describedby="passwordHelpBlock"
                                        />
                                      </div>
                                    </div>
                                  </td>

                                  <td align="left">
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <div style={{ width: "80px" }}>
                                        <Form.Control
                                          type="number"
                                          id=""
                                          name=""
                                          value="50"
                                          // step="0.01"
                                          step="0.1"
                                          min="0"
                                          // aria-describedby="passwordHelpBlock"
                                        />
                                      </div>

                                      <div
                                        style={{
                                          width: "60px",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <Form.Select
                                          value="$"
                                          id=""
                                          name=""
                                          aria-label="Default select example"
                                        >
                                          <option>$</option>
                                          <option>%</option>
                                        </Form.Select>
                                      </div>
                                    </div>
                                  </td>

                                  <td
                                    align="right"
                                    className="line_total_amount text-right"
                                  >
                                    14,950.00
                                  </td>

                                  <td align="left">
                                    <div className="icon-button-parent">
                                      {<ActionButtonCall btnname="close" />}
                                    </div>
                                  </td>
                                </tr>

                                <tr>
                                  <td align="left">
                                    Re-wired low volt in to new one
                                  </td>
                                  <td align="left">Master</td>
                                  <td align="right">
                                    <div style={{ display: "flex" }}>
                                      <div style={{ width: "120px" }}>
                                        <Form.Control
                                          type="number"
                                          id=""
                                          name=""
                                          value="3500.00"
                                          // step="0.01"
                                          step="0.1"
                                          min="0"
                                          // aria-describedby="passwordHelpBlock"
                                        />
                                      </div>
                                    </div>
                                  </td>
                                  <td align="right">
                                    <div style={{ display: "flex" }}>
                                      <div style={{ width: "70px" }}>
                                        <Form.Control
                                          type="number"
                                          id=""
                                          name=""
                                          value="1"
                                          // step="0.01"
                                          step="1"
                                          min="0"
                                          // aria-describedby="passwordHelpBlock"
                                        />
                                      </div>
                                    </div>
                                  </td>

                                  <td align="left">
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <div style={{ width: "80px" }}>
                                        <Form.Control
                                          type="number"
                                          id=""
                                          name=""
                                          value="25"
                                          // step="0.01"
                                          step="0.1"
                                          min="0"
                                          // aria-describedby="passwordHelpBlock"
                                        />
                                      </div>

                                      <div style={{ width: "60px" }}>
                                        <Form.Select
                                          value="$"
                                          id=""
                                          name=""
                                          aria-label="Default select example"
                                        >
                                          <option>$</option>
                                          <option>%</option>
                                        </Form.Select>
                                      </div>
                                    </div>
                                  </td>

                                  <td
                                    align="right"
                                    className="line_total_amount text-right"
                                  >
                                    3,475.00
                                  </td>

                                  <td align="left">
                                    <div className="icon-button-parent">
                                      {<ActionButtonCall btnname="close" />}
                                    </div>
                                  </td>
                                </tr>

                                <tr>
                                  <td align="left">
                                    Replaced new digital thermostat
                                  </td>
                                  <td align="left">Custom</td>
                                  <td align="right">
                                    <div style={{ display: "flex" }}>
                                      <div style={{ width: "120px" }}>
                                        <Form.Control
                                          type="number"
                                          id=""
                                          name=""
                                          value="2500.00"
                                          // step="0.01"
                                          step="0.1"
                                          min="0"
                                          // aria-describedby="passwordHelpBlock"
                                        />
                                      </div>
                                    </div>
                                  </td>
                                  <td align="right">
                                    <div style={{ display: "flex" }}>
                                      <div style={{ width: "70px" }}>
                                        <Form.Control
                                          type="number"
                                          id=""
                                          name=""
                                          value="2"
                                          // step="0.01"
                                          step="1"
                                          min="0"
                                          // aria-describedby="passwordHelpBlock"
                                        />
                                      </div>
                                    </div>
                                  </td>

                                  <td align="left">
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <div style={{ width: "80px" }}>
                                        <Form.Control
                                          type="number"
                                          id=""
                                          name=""
                                          value="2"
                                          // step="0.01"
                                          step="0.1"
                                          min="0"
                                          // aria-describedby="passwordHelpBlock"
                                        />
                                      </div>

                                      <div style={{ width: "60px" }}>
                                        <Form.Select
                                          value="%"
                                          id=""
                                          name=""
                                          aria-label="Default select example"
                                        >
                                          <option>$</option>
                                          <option>%</option>
                                        </Form.Select>
                                      </div>
                                    </div>
                                  </td>

                                  <td
                                    align="right"
                                    className="line_total_amount text-right"
                                  >
                                    4,900.00
                                  </td>

                                  <td align="left">
                                    <div className="icon-button-parent">
                                      {<ActionButtonCall btnname="close" />}
                                    </div>
                                  </td>
                                </tr>

                                <tr>
                                  <td align="left">
                                    Programed thermostat in to heat pump mode
                                  </td>
                                  <td align="left">Master</td>
                                  <td align="right">
                                    <div style={{ display: "flex" }}>
                                      <div style={{ width: "120px" }}>
                                        <Form.Control
                                          type="number"
                                          id=""
                                          name=""
                                          value="4300.00"
                                          // step="0.01"
                                          step="0.1"
                                          min="0"
                                          // aria-describedby="passwordHelpBlock"
                                        />
                                      </div>
                                    </div>
                                  </td>
                                  <td align="right">
                                    <div style={{ display: "flex" }}>
                                      <div style={{ width: "70px" }}>
                                        <Form.Control
                                          type="number"
                                          id=""
                                          name=""
                                          value="1"
                                          // step="0.01"
                                          step="1"
                                          min="0"
                                          // aria-describedby="passwordHelpBlock"
                                        />
                                      </div>
                                    </div>
                                  </td>

                                  <td align="left">
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <div style={{ width: "80px" }}>
                                        <Form.Control
                                          type="number"
                                          id=""
                                          name=""
                                          value="25"
                                          // step="0.01"
                                          step="0.1"
                                          min="0"
                                          // aria-describedby="passwordHelpBlock"
                                        />
                                      </div>

                                      <div style={{ width: "60px" }}>
                                        <Form.Select
                                          value="$"
                                          id=""
                                          name=""
                                          aria-label="Default select example"
                                        >
                                          <option>$</option>
                                          <option>%</option>
                                        </Form.Select>
                                      </div>
                                    </div>
                                  </td>

                                  <td
                                    align="right"
                                    className="line_total_amount text-right"
                                  >
                                    4,275.00
                                  </td>

                                  <td align="left">
                                    <div className="icon-button-parent">
                                      {<ActionButtonCall btnname="close" />}
                                    </div>
                                  </td>
                                </tr>

                                <tr>
                                  <td align="left">
                                    Checked central air conditioning unit
                                  </td>
                                  <td align="left">Custom</td>
                                  <td align="right">
                                    <div style={{ display: "flex" }}>
                                      <div style={{ width: "120px" }}>
                                        <Form.Control
                                          type="number"
                                          id=""
                                          name=""
                                          value="1900.00"
                                          // step="0.01"
                                          step="0.1"
                                          min="0"
                                          // aria-describedby="passwordHelpBlock"
                                        />
                                      </div>
                                    </div>
                                  </td>
                                  <td align="right">
                                    <div style={{ display: "flex" }}>
                                      <div style={{ width: "70px" }}>
                                        <Form.Control
                                          type="number"
                                          id=""
                                          name=""
                                          value="1"
                                          // step="0.01"
                                          step="1"
                                          min="0"
                                          // aria-describedby="passwordHelpBlock"
                                        />
                                      </div>
                                    </div>
                                  </td>

                                  <td align="left">
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <div style={{ width: "80px" }}>
                                        <Form.Control
                                          type="number"
                                          id=""
                                          name=""
                                          value="50"
                                          // step="0.01"
                                          step="0.1"
                                          min="0"
                                          // aria-describedby="passwordHelpBlock"
                                        />
                                      </div>

                                      <div style={{ width: "60px" }}>
                                        <Form.Select
                                          value="$"
                                          id=""
                                          name=""
                                          aria-label="Default select example"
                                        >
                                          <option>$</option>
                                          <option>%</option>
                                        </Form.Select>
                                      </div>
                                    </div>
                                  </td>

                                  <td
                                    align="right"
                                    className="line_total_amount text-right"
                                  >
                                    1,850.00
                                  </td>

                                  <td align="left">
                                    <div className="icon-button-parent">
                                      {<ActionButtonCall btnname="close" />}
                                    </div>
                                  </td>
                                </tr>

                                <tr>
                                  <td colSpan="5" textalign="left">
                                    <span class="lg-td-elmt text-upper-elmt">
                                      Total before Discount
                                    </span>
                                  </td>
                                  <td align="right">
                                    <span class="lg-td-elmt">29,450.00</span>
                                  </td>
                                  <td></td>
                                </tr>

                                <tr>
                                  <td textalign="left">Discount</td>
                                  <td colSpan="4" align="right">
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <div style={{ width: "80px" }}>
                                        <Form.Control
                                          type="number"
                                          id=""
                                          name=""
                                          value="5"
                                          // step="0.01"
                                          step="0.1"
                                          min="0"
                                          // aria-describedby="passwordHelpBlock"
                                        />
                                      </div>

                                      <div style={{ width: "60px" }}>
                                        <Form.Select
                                          value="%"
                                          id=""
                                          name=""
                                          aria-label="Default select example"
                                        >
                                          <option>$</option>
                                          <option>%</option>
                                        </Form.Select>
                                      </div>
                                    </div>
                                  </td>
                                  <td align="right">1,472.50</td>
                                  <td></td>
                                </tr>

                                <tr>
                                  <td colSpan="5" textalign="left">
                                    <span class="lg-td-elmt text-upper-elmt">
                                      Total after Discount
                                    </span>
                                  </td>
                                  <td align="right">
                                    <span class="lg-td-elmt">27,977.50</span>
                                  </td>
                                  <td></td>
                                </tr>

                                <tr>
                                  <td textalign="left">Service Charge</td>
                                  <td colSpan="4" align="right">
                                    10%
                                  </td>
                                  <td align="right">2,797.70</td>
                                  <td></td>
                                </tr>

                                <tr>
                                  <td textalign="left">Tax</td>
                                  <td colSpan="4" align="right">
                                    10%
                                  </td>
                                  <td align="right">2,797.70</td>
                                  <td></td>
                                </tr>

                                <tr>
                                  <td colSpan="5" textalign="left">
                                    <span class="lg-td-elmt text-upper-elmt">
                                      Invoice Total
                                    </span>
                                  </td>
                                  <td align="right">
                                    <span class="lg-td-elmt">33,572.90</span>
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={12} lg={12} className="lable-before_after-unsetter-con">
                <div className="form-group-con">
                  <Form.Label htmlFor="addJobDesc">Note</Form.Label>
                  <FloatingLabel label="">
                    <Form.Control
                      as="textarea"
                      placeholder="Notes"
                      style={{ height: "100px" }}
                      id="addJobDesc"
                      value="Checked central AC and heating system.&#013;&#010;Unit not starting.&#013;&#010;Opened attic and checked air handler in attic.&#013;&#010;Found unit low voltage wire was shorted and transformer was burnt out.&#013;&#010;Replaced transformer and repair low voltage issue.&#013;&#010;Checked thermostat and existing thermostat was not working.&#013;&#010;Removed faulty thermostat and replaced new thermostat."
                    />
                  </FloatingLabel>
                </div>
              </Col>

              <Col xs={12} md={12} lg={12} className="lable-before_after-unsetter-con">
                <div className="form-group-con">
                  <Form.Label htmlFor="addJobDesc">Warnings and Suggestions</Form.Label>
                  <FloatingLabel label="">
                    <Form.Control
                      as="textarea"
                      placeholder="Notes"
                      style={{ height: "100px" }}
                      id="addJobDesc"
                      value="Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt."
                    />
                  </FloatingLabel>
                </div>
              </Col>
            </Row>
            {/* <Row>
              <Col
                md={{ span: 3, offset: 3 }}
              >{`md={{ span: 3, offset: 3 }}`}</Col>
              <Col
                md={{ span: 3, offset: 3 }}
              >{`md={{ span: 3, offset: 3 }}`}</Col>
            </Row>
            <Row>
              <Col
                md={{ span: 6, offset: 3 }}
              >{`md={{ span: 6, offset: 3 }}`}</Col>
            </Row> */}
          </Container>

          {/* <Container className="cus-con-elmt">
            <Row>
             
            </Row>
          </Container> */}

          <Container className="cus-con-elmt bottom-btn-set-sec">
            <Row>
              <Col xs={12} md={12} lg={12}>
                <div className="grid-sec-row">
                  <div className="grid-sec-col grid-sec-col-left-align grid-667max-sec-col-center-align grid-sec-col-2 max-767-hider-elmtXXX">
                    <ButtonCall
                      urlto="/job-accounts"
                      btnname="back"
                      title="Back"
                    />
                  </div>

                  <div className="grid-sec-col grid-sec-col-right-align grid-667max-sec-col-center-align grid-sec-col-2">
                    <ButtonCall
                      urlto="/job-accounts"
                      btnname="save"
                      title="Update"
                    />

                    <ButtonCall
                      urlto="/comingsoon"
                      btnname="save-invoice"
                      title="Update and Raise Invoice"
                    />

                    <ButtonCall
                      urlto="/job-accounts"
                      btnname="close"
                      title="Cancel"
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>

          <>
            <Modal
              show={showAddJob}
              onHide={handleClose}
              className="full-modal-con"
            >
              {modalType == "add-company" && (
                <>
                  <Modal.Header closeButton>
                    <Modal.Title>Add New Company</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <>
                        <Container className="cus-con-elmt">
                          <Row>
                            <Col xs={12} md={12} lg={12}>
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobTitle">
                                  Company Name
                                </Form.Label>
                                <Form.Control
                                  value={insertCustomItem.CustomItemName}
                                  type="text"
                                  id="CustomItemName"
                                  name="CustomItemName"
                                  onChange={insertCustomItemParser}
                                  // aria-describedby="passwordHelpBlock"
                                />
                                {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                              </div>
                            </Col>

                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="lable-before_after-unsetter-con"
                            >
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobDesc">
                                  Description
                                </Form.Label>
                                <FloatingLabel label="">
                                  <Form.Control
                                    value={
                                      insertCustomItem.CustomItemDescription
                                    }
                                    as="textarea"
                                    placeholder=""
                                    style={{ height: "100px" }}
                                    id="CustomItemDescription"
                                    name="CustomItemDescription"
                                    onChange={insertCustomItemParser}
                                  />
                                </FloatingLabel>
                              </div>
                            </Col>

                            {/* <Col xs={12} md={4} lg={4}>
                            <div className="form-group-con">
                              <Form.Label htmlFor="addJobTitle">
                                Unit
                              </Form.Label>
                              <Form.Control
                                value={insertCustomItem.CustomItemUnit}
                                type="text"
                                id="CustomItemUnit"
                                name="CustomItemUnit"
                                onChange={insertCustomItemParser}
                              />
                             
                            </div>
                          </Col> */}

                            <Col xs={12} md={4} lg={4}>
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobTitle">
                                  Phone
                                </Form.Label>
                                <Form.Control
                                  value=""
                                  type="text"
                                  // id="CustomItemName"
                                  // name="CustomItemName"
                                  // onChange={insertCustomItemParser}
                                  // aria-describedby="passwordHelpBlock"
                                />
                                {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                              </div>
                            </Col>

                            <Col xs={12} md={4} lg={4}>
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobTitle">
                                  Email
                                </Form.Label>
                                <Form.Control
                                  value=""
                                  type="email"
                                  // id="CustomItemName"
                                  // name="CustomItemName"
                                  // onChange={insertCustomItemParser}
                                  // aria-describedby="passwordHelpBlock"
                                />
                                {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                              </div>
                            </Col>
                          </Row>
                        </Container>
                      </>
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    {
                      <UnLinkButton
                        trigerClick={handleClose}
                        btnname="close"
                        title="Cancel"
                      />
                    }
                    {/* SubmitinsertMasterItemParser */}
                    {
                      <UnLinkButton
                        trigerClick={handleClose}
                        btnname="save"
                        title="Save"
                      />
                    }
                  </Modal.Footer>
                </>
              )}

              {modalType == "add-contact" && (
                <>
                  <Modal.Header closeButton>
                    <Modal.Title>Add New Contact</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <>
                        <Container className="cus-con-elmt">
                          <Row>
                            <Col xs={12} md={12} lg={12}>
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobTitle">
                                  Contact Name
                                </Form.Label>
                                <Form.Control
                                  value={insertCustomItem.CustomItemName}
                                  type="text"
                                  id="CustomItemName"
                                  name="CustomItemName"
                                  onChange={insertCustomItemParser}
                                  // aria-describedby="passwordHelpBlock"
                                />
                                {/* <Form.Text id="passwordHelpBlock" muted>
     ...
   </Form.Text> */}
                              </div>
                            </Col>

                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="lable-before_after-unsetter-con"
                            >
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobDesc">
                                  Description
                                </Form.Label>
                                <FloatingLabel label="">
                                  <Form.Control
                                    value={
                                      insertCustomItem.CustomItemDescription
                                    }
                                    as="textarea"
                                    placeholder=""
                                    style={{ height: "100px" }}
                                    id="CustomItemDescription"
                                    name="CustomItemDescription"
                                    onChange={insertCustomItemParser}
                                  />
                                </FloatingLabel>
                              </div>
                            </Col>

                            {/* <Col xs={12} md={4} lg={4}>
             <div className="form-group-con">
               <Form.Label htmlFor="addJobTitle">
                 Unit
               </Form.Label>
               <Form.Control
                 value={insertCustomItem.CustomItemUnit}
                 type="text"
                 id="CustomItemUnit"
                 name="CustomItemUnit"
                 onChange={insertCustomItemParser}
               />
              
             </div>
           </Col> */}

                            <Col xs={12} md={4} lg={4}>
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobCat">
                                  Company
                                </Form.Label>
                                <Form.Select
                                  id="addJobCat"
                                  aria-label="Default select example"
                                >
                                  <option>Select Company</option>
                                  <option value="1">Las Ventanas</option>
                                  <option value="2">Saepe Eveniet</option>
                                  <option value="3">
                                    Voluptates Repudiandae
                                  </option>
                                </Form.Select>
                              </div>
                            </Col>

                            <Col xs={12} md={4} lg={4}>
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobTitle">
                                  Phone
                                </Form.Label>
                                <Form.Control
                                  value=""
                                  type="text"
                                  // id="CustomItemName"
                                  // name="CustomItemName"
                                  // onChange={insertCustomItemParser}
                                  // aria-describedby="passwordHelpBlock"
                                />
                                {/* <Form.Text id="passwordHelpBlock" muted>
     ...
   </Form.Text> */}
                              </div>
                            </Col>

                            <Col xs={12} md={4} lg={4}>
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobTitle">
                                  Email
                                </Form.Label>
                                <Form.Control
                                  value=""
                                  type="email"
                                  // id="CustomItemName"
                                  // name="CustomItemName"
                                  // onChange={insertCustomItemParser}
                                  // aria-describedby="passwordHelpBlock"
                                />
                                {/* <Form.Text id="passwordHelpBlock" muted>
     ...
   </Form.Text> */}
                              </div>
                            </Col>
                          </Row>
                        </Container>
                      </>
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    {
                      <UnLinkButton
                        trigerClick={handleClose}
                        btnname="close"
                        title="Cancel"
                      />
                    }
                    {/* SubmitinsertMasterItemParser */}
                    {
                      <UnLinkButton
                        trigerClick={handleClose}
                        btnname="save"
                        title="Save"
                      />
                    }
                  </Modal.Footer>
                </>
              )}

              {modalType == "edit-item" && (
                <>
                  <Modal.Header closeButton>
                    <Modal.Title>Add New Items to the Job</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <div className="checker-inline-con">
                        <Form.Check
                          type="radio"
                          id="itemtype-master"
                          label="Master Item"
                          name="itemtype"
                          className="radio-btn-elmt"
                          value="master"
                          onChange={() => {
                            SetaddJobInventoryType("master");
                            setinsertMasterItem({
                              selectMasterItem: "",
                              MasterItemCount: "",
                            });
                            setinsertCustomItem({
                              CustomItemName: "",
                              CustomItemDescription: "",
                              CustomItemCount: "",
                              CustomItemUnit: "",
                              CustomItemPrice: "",
                            });
                            // SetjobInventoryBodyType("master");
                          }}
                          checked={addJobInventoryType == "master"}
                        />

                        <Form.Check
                          type="radio"
                          id="itemtype-cutom"
                          label="Custom Item"
                          name="itemtype"
                          className="radio-btn-elmt"
                          value="custom"
                          onChange={() => {
                            SetaddJobInventoryType("custom");
                            setinsertMasterItem({
                              selectMasterItem: "",
                              MasterItemCount: "",
                            });
                            setinsertCustomItem({
                              CustomItemName: "",
                              CustomItemDescription: "",
                              CustomItemCount: "",
                              CustomItemUnit: "",
                              CustomItemPrice: "",
                            });
                            // SetjobInventoryBodyType("custom");
                          }}
                          checked={addJobInventoryType == "custom"}
                        />
                      </div>

                      {addJobInventoryType == "master" && (
                        <>
                          <Container className="cus-con-elmt">
                            <Row>
                              <Col xs={12} md={6} lg={6}>
                                <div className="form-group-con">
                                  <div className="form-group-con-btn">
                                    <div className="form-group-con-btn-col-1">
                                      <Form.Label htmlFor="addJobSelectCompany">
                                        Category
                                      </Form.Label>

                                      <Form.Select
                                        value={
                                          SelectedMasterDataStore.MasterDataCategory
                                        }
                                        name="MasterDataCategory"
                                        // value={SelectedCompanyStore.company}
                                        // onChange={handleCpmpanyInput}
                                        onChange={handleMasterDataInput}
                                        id="MasterDataCategory"
                                        aria-label="Default select example"
                                      >
                                        <option>
                                          Select Master Item Category
                                        </option>
                                        {CatMasterDataStore.map((item) => (
                                          <option
                                            key={item.id}
                                            value={item.code}
                                            name={item.code}
                                          >
                                            {item.name}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </div>
                                  </div>
                                </div>
                              </Col>

                              <Col xs={12} md={6} lg={6}>
                                <div className="form-group-con">
                                  <div className="form-group-con-btn">
                                    <div className="form-group-con-btn-col-1">
                                      <Form.Label htmlFor="addJobSelectCustomer">
                                        Item
                                      </Form.Label>
                                      <Form.Select
                                        value={
                                          insertMasterItem.selectMasterItem
                                        }
                                        onChange={insertMasterItemParser}
                                        id="selectMasterItem"
                                        name="selectMasterItem"
                                        aria-label="Default select example"
                                      >
                                        <option>Select Master Item</option>
                                        {MasterDataStore.filter(
                                          (masterdata) =>
                                            masterdata.enable == 1 &&
                                            masterdata.category ==
                                              `${SelectedMasterDataStore.MasterDataCategory}`
                                        ).map((item) => (
                                          <option
                                            key={item.id}
                                            value={item.code}
                                          >
                                            {item.code} - {item.name}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </div>
                                  </div>
                                </div>
                              </Col>

                              {/* new 1 + 2 */}
                              <Col xs={12} md={6} lg={6}>
                                <div className="form-group-con">
                                  <div className="form-group-con-btn form-group-con-btn-one-h">
                                    <div
                                      className="form-group-con-btn-col-1"
                                      style={{ width: "120px" }}
                                    >
                                      <Form.Label htmlFor="addJobTitle">
                                        Count
                                      </Form.Label>
                                      <Form.Control
                                        value={insertMasterItem.MasterItemCount}
                                        type="number"
                                        id="MasterItemCount"
                                        name="MasterItemCount"
                                        onChange={insertMasterItemParser}
                                        min="1"
                                        // aria-describedby="passwordHelpBlock"
                                      />
                                    </div>

                                    <div className="form-group-con-btn-col-2">
                                      {/* <div className="form-group-con-btn-col-2-none-h-elmt"> */}

                                      {/* use this */}
                                      {/* {MasterDataStore.filter(
                                      (masterdata) =>
                                        masterdata.enable == 1 &&
                                        masterdata.code ==
                                          `${insertMasterItem.selectMasterItem}`
                                    ).map((item) => (
                                      <span key={item.id}>{item.unit}</span>
                                    ))} */}
                                      <div
                                        className="form-group-con-btn-col-2"
                                        style={{ width: "90px" }}
                                      >
                                        <Form.Label htmlFor="addJobSelectCustomer">
                                          Unit
                                        </Form.Label>
                                        <Form.Select
                                          value={
                                            insertCustomItem.CustomItemUnit
                                          }
                                          onChange={insertCustomItemParser}
                                          id="CustomItemUnit"
                                          name="CustomItemUnit"
                                          aria-label="Default select example"
                                        >
                                          <option>NOs</option>
                                          {Unit.map((item) => (
                                            <option
                                              key={item.id}
                                              value={item.code}
                                            >
                                              {item.name}
                                            </option>
                                          ))}
                                        </Form.Select>
                                        {/* </div> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Col>

                              <Col xs={12} md={4} lg={4}>
                                <div className="form-group-con">
                                  <div className="form-group-con-btn">
                                    <div className="form-group-con-btn-col-1">
                                      <Form.Label htmlFor="addJobSelectCustomer">
                                        Price
                                      </Form.Label>

                                      {/* <Form.Select
                                    value={insertMasterItem.selectMasterItem}
                                    onChange={insertMasterItemParser}
                                    id="selectMasterItem"
                                    name="selectMasterItem"
                                    aria-label="Default select example"
                                  >
                                    <option>Item Price</option> */}
                                      {MasterDataStore.filter(
                                        (masterdata) =>
                                          masterdata.enable == 1 &&
                                          masterdata.code ==
                                            `${insertMasterItem.selectMasterItem}`
                                      ).map((item) => (
                                        <option key={item.id} value={item.code}>
                                          <>
                                            {item.price &&
                                              item.price.toLocaleString()}{" "}
                                            USD
                                          </>
                                        </option>
                                      ))}
                                      {/* </Form.Select> */}
                                    </div>
                                  </div>
                                </div>
                              </Col>

                              <Col xs={12} md={6} lg={6}>
                                <div className="form-group-con">
                                  <Form.Label htmlFor="addJobTitle">
                                    Image
                                  </Form.Label>
                                  <Form.Control
                                    type="file"
                                    // aria-describedby="passwordHelpBlock"
                                  />
                                  {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}

                                  {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                                </div>
                              </Col>
                            </Row>
                          </Container>
                        </>
                      )}

                      {addJobInventoryType == "custom" && (
                        <>
                          <Container className="cus-con-elmt">
                            <Row>
                              <Col xs={12} md={12} lg={12}>
                                <div className="form-group-con">
                                  <Form.Label htmlFor="addJobTitle">
                                    Title
                                  </Form.Label>
                                  <Form.Control
                                    value={insertCustomItem.CustomItemName}
                                    type="text"
                                    id="CustomItemName"
                                    name="CustomItemName"
                                    onChange={insertCustomItemParser}
                                    // aria-describedby="passwordHelpBlock"
                                  />
                                  {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                                </div>
                              </Col>

                              <Col xs={12} md={12} lg={12}>
                                <div className="form-group-con">
                                  <Form.Label htmlFor="addJobDesc">
                                    Description
                                  </Form.Label>
                                  <FloatingLabel label="">
                                    <Form.Control
                                      value={
                                        insertCustomItem.CustomItemDescription
                                      }
                                      as="textarea"
                                      placeholder=""
                                      style={{ height: "100px" }}
                                      id="CustomItemDescription"
                                      name="CustomItemDescription"
                                      onChange={insertCustomItemParser}
                                    />
                                  </FloatingLabel>
                                </div>
                              </Col>

                              {/* <Col xs={12} md={4} lg={4}>
                            <div className="form-group-con">
                              <Form.Label htmlFor="addJobTitle">
                                Unit
                              </Form.Label>
                              <Form.Control
                                value={insertCustomItem.CustomItemUnit}
                                type="text"
                                id="CustomItemUnit"
                                name="CustomItemUnit"
                                onChange={insertCustomItemParser}
                              />
                             
                            </div>
                          </Col> */}

                              <Col xs={12} md={6} lg={6}>
                                <div className="form-group-con">
                                  <div className="form-group-con-btn">
                                    <div
                                      className="form-group-con-btn-col-1"
                                      style={{ width: "120px" }}
                                    >
                                      <Form.Label htmlFor="addJobTitle">
                                        Count
                                      </Form.Label>
                                      <Form.Control
                                        value={insertCustomItem.CustomItemCount}
                                        type="number"
                                        id="CustomItemCount"
                                        name="CustomItemCount"
                                        onChange={insertCustomItemParser}
                                        min="1"
                                        // aria-describedby="passwordHelpBlock"
                                      />
                                      {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                                    </div>

                                    <div
                                      className="form-group-con-btn-col-2"
                                      style={{ width: "90px" }}
                                    >
                                      <Form.Label htmlFor="addJobSelectCustomer">
                                        Unit
                                      </Form.Label>
                                      <Form.Select
                                        value={insertCustomItem.CustomItemUnit}
                                        onChange={insertCustomItemParser}
                                        id="CustomItemUnit"
                                        name="CustomItemUnit"
                                        aria-label="Default select example"
                                      >
                                        <option>NOs</option>
                                        {Unit.map((item) => (
                                          <option
                                            key={item.id}
                                            value={item.code}
                                          >
                                            {item.name}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </div>
                                  </div>
                                </div>
                              </Col>

                              <Col xs={12} md={6} lg={6}>
                                <div
                                  className="form-group-con"
                                  style={{ width: "120px" }}
                                >
                                  <Form.Label htmlFor="addJobTitle">
                                    Price
                                  </Form.Label>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                      justifyContent: "flex-start",
                                      gap: "6px",
                                    }}
                                  >
                                    <Form.Control
                                      value={insertCustomItem.CustomItemPrice}
                                      type="number"
                                      id="CustomItemPrice"
                                      name="CustomItemPrice"
                                      onChange={insertCustomItemParser}
                                      min="1"
                                      // aria-describedby="passwordHelpBlock"
                                    />{" "}
                                    <span
                                      style={{
                                        display: "inline-block",
                                        marginTop: "0px",
                                      }}
                                    >
                                      USD
                                    </span>
                                  </div>
                                  {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                                </div>
                              </Col>

                              <Col xs={12} md={6} lg={6}>
                                <div className="form-group-con">
                                  <Form.Label htmlFor="addJobTitle">
                                    Image
                                  </Form.Label>
                                  <Form.Control
                                    type="file"
                                    // aria-describedby="passwordHelpBlock"
                                  />
                                  {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}

                                  {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                                </div>
                              </Col>
                            </Row>
                          </Container>
                        </>
                      )}
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    {
                      <UnLinkButton
                        trigerClick={SubmitinsertAllItemParser}
                        btnname="add"
                        title="Add Item"
                      />
                    }
                    {
                      <UnLinkButton
                        trigerClick={handleClose}
                        btnname="close"
                        title="Close"
                      />
                    }
                    {/* SubmitinsertMasterItemParser */}
                  </Modal.Footer>
                </>
              )}
            </Modal>
          </>
        </div>

        <Footer />
      </div>
    </div>
  );
}
export default AddJob;
